<template>
  <div id="app">
    <board />
  </div>
</template>

<script>
import board from './components/board'

export default {
  name: 'app',
  components : {
    board
  }
}
</script>

<style>
body {
  font-family: helvetica neue,Helvetica,Arial,sans-serif;
  overflow: hidden;
  background-color: rgb(230, 230, 230);
}
#app {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
ul, li {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>
